import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({
  E_PAY_TYPE_DISCOUNT: 0, //优惠
  E_PAY_TYPE_INTEGRAL: 1, //积分
  E_PAY_TYPE_BALANCE: 2, //积分(余额)
  E_PAY_TYPE_COUPON: 3, //现金券
  E_PAY_TYPE_CARD: 4, //苏打券
  // 售后类型
  SERVICE_TYPE_REFUND_ALL: 0, //整单退款
  SERVICE_TYPE_REFUND_GOOD: 1, //退货
  SERVICE_TYPE_EXCHANGE_GOOD: 2, //换货
  SERVICE_TYPE_ONLY_REFUND: 3, //仅退款 （目前优先培仅退款和发货后仅退款 都 返回3）
  SERVICE_TYPE_REFUND: 4, //未发货退款
  SERVICE_TYPE_FIXADD_GOOD: 6,  //补货, 仅退款 (只有补货返回6， serviceProcess： 优先培仅退款)

  SERVICE_TYPE_FIXADD_REPLENISH_GOOD: 7, // (serviceProcess： 优先培补货 )
  // 退款类型
  REFUND_TYPE_AUTO: 0, //自动计算
  REFUND_TYPE_CUSTOM: 1, //自定义
  REFUND_TYPE_RATIO: 2, //按比例选择

  REFUND_UPLOAD_VIDEO_POSTER: 'https://mall.s.maizuo.com/d8dd67c81de11724d9aafe428e3dd1a78858a8bc-def2-4d7a-a09a-9928d747af20.png', // 上传视频缩略图
  // 协商历史节点
  REFUND_HISTORY_FLOW_IS_CREATE: 1, //发起售后申请
  REFUND_HISTORY_FLOW_IS_KEFU_AGREE: 2, //客服审核
  REFUND_HISTORY_FLOW_IS_KEFU_AGREE_OR_BUSINESS_AGREE: 3, //客服审核&商家确认
  REFUND_HISTORY_FLOW_IS_RETURN_EXPRESS: 4,//商品寄回
  REFUND_HISTORY_FLOW_IS_KEFU_CONFIRM_EXCHANGE: 5,//换货确认
  REFUND_HISTORY_FLOW_IS_KEFU_CONFIRM_REFUND_GOOD: 6,//确认退货
  REFUND_HISTORY_FLOW_IS_KEFU_CONFIRM_REFUND: 7,//退款确认
  REFUND_HISTORY_FLOW_IS_END: 8,//结束
  REFUND_HISTORY_FLOW_IS_CANCEL: 9,//取消
  REFUND_HISTORY_FLOW_IS_CHANGE_RATE: 11,//更换退款比例

  // 售后状态
  REFUND_SERVICE_STATUS_WAIT_KF_CEHCK: 0, //待客服处理
  REFUND_SERVICE_STATUS_WAIT_RETURN: 1, //待用户寄回
  REFUND_SERVICE_STATUS_WAIT_RECEIVED: 2, //待商家收货
  REFUND_SERVICE_STATUS_WAIT_CONFITM: 8, //待商家确认
  REFUND_SERVICE_STATUS_CANCEL: 9, //取消

  // 退货方式
  REFUND_SEND_BACK_TYPE_NORMAL: 0, //默认(非京东普通订单)
  REFUND_SEND_BACK_TYPE_SELF: 1, //自行寄回
  REFUND_SEND_BACK_TYPE_PICKUP: 2, //上门取件
}, km({

  REFUND_GET_LIST_SUCCESS: null,
  REFUND_GET_LIST_ERROR: null,
  REFUND_GET_LIST_EMPTY: null,
  REFUND_GET_LIST_MORE_EMPTY: null,
  REFUND_GET_LIST_MORE_SUCCESS: null,
  REFUND_GET_LIST_MORE_ERROR: null,

  REFUND_GET_DETAIL_SUCCESS: null,
  REFUND_GET_DETAIL_ERROR: null,

  REFUND_GET_REASON_SUCCESS: null,
  REFUND_GET_REASON_EMPTY: null,
  REFUND_GET_REASON_ERROR: null,

  REFUND_GET_SERVICE_TYPE_EMPTY: null,
  REFUND_GET_SERVICE_TYPE_SUCCESS: null,
  REFUND_GET_SERVICE_TYPE_ERROR: null,

  REFUND_GET_EXPRESS_COMPANY_LIST_EMPTY: null,
  REFUND_GET_EXPRESS_COMPANY_LIST_SUCCESS: null,
  REFUND_GET_EXPRESS_COMPANY_LIST_ERROR: null,

  REFUND_GET_AMOUNT_SUCCESS: null,
  REFUND_GET_AMOUNT_ERROR: null,

  REFUND_GET_RATE_OPTIONS_EMPTY: null,
  REFUND_GET_RATE_OPTIONS_SUCCESS: null,
  REFUND_GET_RATE_OPTIONS_ERROR: null,
}))
